import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { NULL_ADDRESS } from 'shared/constants/constants';

export interface State {
  isLoading: boolean;
  invitedBy: `0x${string}`;
  notFirstTime: boolean;
  isMobileBannerClosed: boolean;
  jwt: Record<`0x${string}`, string>;
  jwtValidUntil: Record<`0x${string}`, number>;
  leaderboardMap: Record<string, string>;
}

export interface Actions {
  setIsLoading: (flag: boolean) => void;
  setInvited: (arg0: `0x${string}`) => void;
  setNotFirstTime: (flag: boolean) => void;
  setIsMobileBannerClosed: (flag: boolean) => void;
  setJwt: ({ address, jwt }: { address: `0x${string}` | undefined; jwt: string }) => void;
  setJwtValidUntil: ({
    address,
    jwtValidUntil,
  }: {
    address: `0x${string}` | undefined;
    jwtValidUntil: number;
  }) => void;
  setLeaderboardMap: (map: Record<string, string>) => void;
}

export const initialState: State = {
  isLoading: false,
  invitedBy: NULL_ADDRESS,
  notFirstTime: false,
  isMobileBannerClosed: false,
  jwt: {},
  jwtValidUntil: {},
  leaderboardMap: {},
};

export const useGlobalStore = create<State & Actions>()(
  persist(
    immer((set) => ({
      ...initialState,
      setIsLoading: (newFlag) =>
        set(() => ({
          isLoading: newFlag,
        })),
      setInvited: (address) =>
        set(() => ({
          invitedBy: address,
        })),
      setNotFirstTime: (flag) =>
        set(() => ({
          notFirstTime: flag,
        })),
      setIsMobileBannerClosed: (flag) =>
        set(() => ({
          isMobileBannerClosed: flag,
        })),
      setJwt: ({ address, jwt }) =>
        set((state) => ({
          jwt: { ...state.jwt, [address!]: jwt },
        })),
      setJwtValidUntil: ({ address, jwtValidUntil }) =>
        set((state) => ({
          jwtValidUntil: { ...state.jwtValidUntil, [address!]: jwtValidUntil },
        })),
      setLeaderboardMap: (map) =>
        set(() => ({
          leaderboardMap: map,
        })),
    })),
    { name: 'globalStore' },
  ),
);
